import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../security/authentication.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService) { }
  active;

  ngOnInit(): void {
  }

  logout() {
    this.authenticationService.logout();
  }

}
